<template>
  <div class="home">
    <header-view />

    <section class="services">
      <div class="container">
        <ServicesCard />
      </div>
    </section>

    <ScrollSection />
    <AccordianView />

   <GetInTouch/>
    <footer-view />

  </div>
</template>

<script>


import HeaderView from "@/components/UiComponents/HeaderView.vue";
import AccordianView from "@/components/UiComponents/AccordianView.vue";
import FooterView from '@/components/UiComponents/FooterView.vue'
import ServicesCard from "@/components/ServicesCard.vue";
import ScrollSection from "@/components/ScrollComponent/ScrollSection.vue";
import GetInTouch from "@/components/ScrollComponent/GetInTouch.vue";
export default {
  name: 'ScrolledView',
  components: {
    ServicesCard,
    ScrollSection,
    GetInTouch,
    HeaderView,
    AccordianView,
    FooterView,
  }
}
</script>
